import { useCallback } from 'react'
import { type MixpanelEvent, MixpanelService } from '@/services/mixpanel'
import type { User } from '@/stores/auth'

export const useMixpanel = () => {
  /**
   * Identify a user in mixpanel
   *
   * This typically does not need to be called, as updates to the user stored in the authStore
   * will trigger automatic calls of this function.
   *
   * Only use this if you specifically need to identify a user in a scenario where normal
   * authentication flow will not suffice.
   */
  const identify = useCallback(
    (userId: string, userProperties: Partial<User> = {}) => {
      MixpanelService.identify(userId, userProperties)
    },
    []
  )

  /**
   * Send a mixpanel track event request
   */
  const track = useCallback(
    (event: MixpanelEvent, properties: Record<string, unknown> = {}) => {
      MixpanelService.track(event, properties)
    },
    []
  )

  return {
    track,
    identify,
  }
}
